import type { FC } from 'react';
import TrashIcon from '@material-ui/icons/DeleteOutlined';
import { IconButton } from '@material-ui/core';
import { ExtraInput } from '../../Forms/ExtraForm/types';
import ExtraIcon from '@material-ui/icons/ExtensionOutlined';

interface Props {
  extra: ExtraInput;
  onDelete?: (id: string) => void;
  onEdit?: () => void;
}

const ExtraSummaryItem: FC<Props> = ({ extra, onDelete, onEdit }) => {
  const handleDelete = () => {
    if (extra.id) {
      onDelete?.(extra.id);
    }
  };
  return (
    <div onClick={onEdit} className="flex items-center justify-between px-3 py-2 hover:bg-gray-50 hover:cursor-pointer">
      <div className="flex items-center">
        <ExtraIcon className="text-blue-800 mr-4" />
        <div className="font-bold">{extra.name}</div>
      </div>
      {onDelete && (
        <div>
          <IconButton
            aria-label="delete"
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              handleDelete();
            }}
          >
            <TrashIcon className="text-red-500" />
          </IconButton>
        </div>
      )}
    </div>
  );
};

export default ExtraSummaryItem;
